let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("GcGD5")).then(() => parcelRequire('i692O'));